import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "elements/Box";
import { Button, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Menu, MenuItem, ListItemText, Tooltip } from "@mui/material";
import { Chip } from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import { PiCircleBold, PiCheckCircleBold } from "react-icons/pi";
import Filters2 from 'elements/Filters/Filters2';
import FiltersApplied2 from 'elements/Filters/FiltersApplied2';
import ProgressBarMulti from './components/ProgressBarMulti';

import "assets/css/main.css";

import GuideReassignDialog from "./GuideReassignDialog";
import GuideDeliveredDialog from "./GuideDeliveredDialog";
import GuideVerifyDialog from "./GuideVerifyDialog";
import CreateRouteDialog from "./CreateRouteDialog";
import { ApiRequest } from "GlobalFunctions";

export default function GuideMainList(props: any) {
  const { setLoading } = props;
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
  }, []);

  const [list, setList] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [filtersValues, setFiltersValues] = useState<any>(() => {
    const today = new Date().toISOString().slice(0, 10);
    return {
      date: {
        value: { startDate: today, endDate: today },
        value_txt: `${today} - ${today}`,
        label: "Fecha"
      }
    };
  });
  const [open, setOpen] = useState(false);
  const [openReassignDialog, setOpenReassignDialog] = useState(false);
  const [openDeliveredDialog, setOpenDeliveredDialog] = useState(false);
  const [openVerifyDialog, setOpenVerifyDialog] = useState(false);
  const [openCreateRouteDialog, setOpenCreateRouteDialog] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedGuideId, setSelectedGuideId] = useState<number | null>(null);
  const [selectedGuideCode, setSelectedGuideCode] = useState<string | null>(null);
  const [selectedVehicleId, setSelectedVehicleId] = useState<number | null>(null);
  const [selectedVehicleName, setSelectedVehicleName] = useState<string | null>(null);
  const [selectedLicensePlate, setSelectedLicensePlate] = useState<string | null>(null);
  const [selectedDeliveredToOffice, setSelectedDeliveredToOffice] = useState<number>(0);
  const [selectedVerified, setSelectedVerified] = useState<number>(0);
  const openMenu = Boolean(anchorEl);

  // Estados para el diálogo de reasignación
  const [reassignGuideCode, setReassignGuideCode] = useState<string | null>(null);
  const [reassignVehicleId, setReassignVehicleId] = useState<number | null>(null);
  const [reassignVehicleName, setReassignVehicleName] = useState<string | null>(null);
  const [reassignLicensePlate, setReassignLicensePlate] = useState<string | null>(null);

  // Estados para el diálogo de verificación
  const [verifyGuideId, setVerifyGuideId] = useState<number | null>(null);
  const [verifyGuideCode, setVerifyGuideCode] = useState<string | null>(null);
  const [verifyCurrentVerified, setVerifyCurrentVerified] = useState<number>(0);

  // Estados para el diálogo de entrega en oficina
  const [deliveredGuideId, setDeliveredGuideId] = useState<number | null>(null);
  const [deliveredGuideCode, setDeliveredGuideCode] = useState<string | null>(null);
  const [deliveredCurrentStatus, setDeliveredCurrentStatus] = useState<number>(0);

  useEffect(() => {
    setLoading(true);
    loadList();
  }, [page, filtersValues]);

  const loadList = async () => {
    setLoading(true);

    await ApiRequest({
      url: '/guides/listGuides',
      method: 'GET',
      query: {
        page: page,
        filters: filtersValues,
      },
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      setResponse: (response: any) => {
        setList(response.list);
        setTotalPages(response.total_pages);
        setLoading(false);
      }
    })
  };

  const filters = [
    { type: "date_range", label: "Fecha", name: "date", value: "January 13, 2025 - January 13, 2025", mandatory: false },
    { type: "text", label: "Código de Guía", name: "guide_code", value: "" },
    { type: "autocomplete", label: "Vehículo", name: "vehicle_id", value: "", endpoint: "/vehicles/list" },
    { type: "select", label: "Estado", name: "status_id", value: "", options: [{label: "Todos", value: ""}, {label: "Asignada", value: "0"}, {label: "En tránsito", value: "1"}, {label: "Terminada", value: "2"}, {label: "Entregada", value: "3"}, {label: "Verificada", value: "4"}] },
  ];

  const setFilters = (tempFilters: any) => {
    setFiltersValues(tempFilters);
    localStorage.setItem('guideFilters', JSON.stringify(tempFilters));
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, guide_id: number, guide_code: string, vehicle_id: number | null, vehicle_name: string, license_plate: string, delivered_to_office: number, verified: number) => {
    setAnchorEl(event.currentTarget);
    setSelectedGuideId(guide_id);
    setSelectedGuideCode(guide_code);
    setSelectedVehicleId(vehicle_id);
    setSelectedVehicleName(vehicle_name);
    setSelectedLicensePlate(license_plate);
    setSelectedDeliveredToOffice(delivered_to_office || 0);
    setSelectedVerified(verified || 0);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleReassign = () => {
    // Guardar datos para el diálogo antes de cerrar el menú
    setReassignGuideCode(selectedGuideCode);
    setReassignVehicleId(selectedVehicleId);
    setReassignVehicleName(selectedVehicleName);
    setReassignLicensePlate(selectedLicensePlate);
    setOpenReassignDialog(true);
    handleMenuClose();
  };

  const handleDelivered = () => {
    setDeliveredGuideId(selectedGuideId);
    setDeliveredGuideCode(selectedGuideCode);
    setDeliveredCurrentStatus(selectedDeliveredToOffice || 0);
    setOpenDeliveredDialog(true);
    handleMenuClose();
  };

  const handleVerify = () => {
    // Guardar datos para el diálogo antes de cerrar el menú
    setVerifyGuideId(selectedGuideId);
    setVerifyGuideCode(selectedGuideCode);
    setVerifyCurrentVerified(selectedVerified);
    setOpenVerifyDialog(true);
    handleMenuClose();
  };

  const handleViewDetails = (guide_id: number, guide_code: string) => {
    navigate(`/guides/routes/${guide_id}`, { state: { guide_code } });
    handleMenuClose();
  };

  const getLifecycleChipProps = (item: any) => {
    switch (item.lifecycle_status) {
      case 0:
        return { label: item.lifecycle_status_label || 'Asignada', color: 'default' as const };
      case 1:
        return { label: item.lifecycle_status_label || 'En tránsito', color: 'info' as const };
      case 2:
        return { label: item.lifecycle_status_label || 'Terminada', color: 'success' as const };
      case 3:
        return { label: item.lifecycle_status_label || 'Entregada', color: 'warning' as const };
      case 4:
        return { label: item.lifecycle_status_label || 'Verificada', color: 'secondary' as const };
      default:
        return { label: item.lifecycle_status_label || 'Asignada', color: 'default' as const };
    }
  };

  return (
    <div id="GuideMainList" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Guías</h2>
            <span className="h2_subtitle">Lista de guías</span>
          </div>
          
          <div className='module_tools'>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddRoadIcon />}
              onClick={() => setOpenCreateRouteDialog(true)}
            >
              Crear Ruta
            </Button>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<TuneIcon />}
              onClick={() => setOpen(true)}
            >
              Filtrar
            </Button>
          </div>
        </div>

        <Filters2 open={open} setOpen={setOpen} filters={filters} setFilters={setFilters} />
        <FiltersApplied2 filtersValues={filtersValues} setFiltersValues={setFiltersValues} filters={filters} />

        <Box id="GuideMainListIn" className="box100">
          <TableContainer>
            <Table aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}># De Guía</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Conductor</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Ayudante 1</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Ayudante 2</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Carro Asignado</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}># De Pedidos</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Estado</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none", textAlign: "center" }}>Verificado</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, i) => (
                  <TableRow key={i} hover role="checkbox">
                    <TableCell>
                      <span className='flex_title'>{item.guide_code}</span>
                      <span className='flex_subtitle'>{item.created_at}</span>
                    </TableCell>

                    <TableCell>
                      {item.driver_full_name && item.driver_full_name.trim() ? item.driver_full_name : '-'}
                    </TableCell>

                    <TableCell>
                      {item.helper1_full_name && item.helper1_full_name.trim() ? item.helper1_full_name : '-'}
                    </TableCell>

                    <TableCell>
                      {item.helper2_full_name && item.helper2_full_name.trim() ? item.helper2_full_name : '-'}
                    </TableCell>

                    <TableCell>
                      <span className='flex_title'>{item.vehicle_name || '-'}</span>
                      <span className='flex_subtitle'>{item.license_plate || '-'}</span>
                    </TableCell>

                    <TableCell>
                      <span className='flex_title'>{item.total_routes} pedidos</span>
                      <ProgressBarMulti
                        total={item.total_routes}
                        delivered={item.delivered_routes}
                        partial={item.partial_routes}
                        returned={item.returned_routes}
                      />
                    </TableCell>

                    <TableCell>
                      {(() => {
                        const chipProps = getLifecycleChipProps(item);
                        return (
                      <Chip 
                        label={chipProps.label}
                        color={chipProps.color}
                      />
                        );
                      })()}
                    </TableCell>

                    <TableCell align="center">
                      {item.verified === 1 ? (
                        <Tooltip title="Verificado" arrow>
                          <span 
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setVerifyGuideId(item.guide_id);
                              setVerifyGuideCode(item.guide_code);
                              setVerifyCurrentVerified(item.verified || 0);
                              setOpenVerifyDialog(true);
                            }}
                          >
                            <PiCheckCircleBold style={{ color: '#4caf50', fontSize: '1.5rem' }} />
                          </span>
                        </Tooltip>
                      ) : (
                        <Tooltip title="No verificado" arrow>
                          <span 
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setVerifyGuideId(item.guide_id);
                              setVerifyGuideCode(item.guide_code);
                              setVerifyCurrentVerified(item.verified || 0);
                              setOpenVerifyDialog(true);
                            }}
                          >
                            <PiCircleBold style={{ color: '#bdbdbd', fontSize: '1.5rem' }} />
                          </span>
                        </Tooltip>
                      )}
                    </TableCell>

                    <TableCell align="right">
                      <IconButton
                        onClick={(e) => handleMenuClick(e, item.guide_id, item.guide_code, item.vehicle_id || null, item.vehicle_name || '', item.license_plate || '', item.delivered_to_office || 0, item.verified || 0)}
                      >
                        <MoreHorizIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(event, value) => setPage(value)}
            color="primary"
            style={{ marginTop: "20px", alignSelf: "center" }}
          />
        </Box>
      </div>

      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={() => selectedGuideId && selectedGuideCode && handleViewDetails(selectedGuideId, selectedGuideCode)}>
          <ListItemText>Detalles</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleReassign}>
          <ListItemText>Reasignar</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDelivered}>
          <ListItemText>Entrega en oficina</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleVerify}>
          <ListItemText>Verificación</ListItemText>
        </MenuItem>
      </Menu>

      <GuideReassignDialog
        setLoading={setLoading}
        openDialog={openReassignDialog}
        setOpenDialog={setOpenReassignDialog}
        loadList={loadList}
        guideCode={reassignGuideCode}
        currentVehicleId={reassignVehicleId}
        currentVehicleName={reassignVehicleName}
        currentLicensePlate={reassignLicensePlate}
      />

      <GuideVerifyDialog
        setLoading={setLoading}
        openDialog={openVerifyDialog}
        setOpenDialog={setOpenVerifyDialog}
        loadList={loadList}
        guideId={verifyGuideId}
        guideCode={verifyGuideCode}
        currentVerified={verifyCurrentVerified}
      />

      <GuideDeliveredDialog
        setLoading={setLoading}
        openDialog={openDeliveredDialog}
        setOpenDialog={setOpenDeliveredDialog}
        loadList={loadList}
        guideId={deliveredGuideId}
        guideCode={deliveredGuideCode}
        currentDeliveredToOffice={deliveredCurrentStatus}
      />

      <CreateRouteDialog
        open={openCreateRouteDialog}
        setOpen={setOpenCreateRouteDialog}
        setLoading={setLoading}
        loadList={loadList}
      />
    </div>
  );
}
